module.exports = __webpack_public_path__ + "static/media/IMG_1231.5380eedd.jpg";